import { Navigate, useLocation } from "react-router";


import HeaderComponent from "../components/HeaderComponent/HeaderComponent";
import Sidebar from "../components/SidebarComponent/Sidebar";
import { useSelector } from "react-redux";

// userMode is store userSlice data, thats is cotrol login status
import { SelectedAccount, userlogout } from "../redux/userSlice";
import { themeMode } from "../redux/themeSlice";
import AdminSidebarComponent from "../AdminSidebarComponent/AdminSidebarComponent";

const ProtectedRoute = ({ children }) => {


  const selectedAccountDetails = useSelector(SelectedAccount);
  const isTokenValid = () => {
    const tokenData = JSON.parse(sessionStorage.getItem('token'));
  
    if (!tokenData) {
      return false;
    }
  
    const currentTime = new Date().getTime();
    
    
    const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
  
   
    if (currentTime - tokenData.timestamp > oneDay) {
      sessionStorage.removeItem('token');
      userlogout();
      return false;
    }
  
    return true;
  };
  
  const getToken = () => {
    if (isTokenValid()) {
      const tokenData = JSON.parse(sessionStorage.getItem('token'));
      return tokenData.value;
    }
    return null;
  };
    
const token=getToken();

const User_Role=sessionStorage.getItem('userRole');

// console.log("User_Role",User_Role)
// if (!token && User_Role!=='Dev'){
//   console.log("login page")
// }else{
//   console.log("Dashboard")
// }

    const thememode=useSelector(themeMode)

  let location = useLocation();

  // if(User_Role!=='Dev'){
  //   console.log("User_Role ===>",User_Role)
    
  // }
 
  // Redirect to login if no token is found
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Redirect based on role if accessing unauthorized paths
  if (User_Role === 'Dev' && location.pathname !== "/dashboard") {
    return <Navigate to="/dashboard" />;
  } else if (User_Role === 'Admin' && !location.pathname.startsWith("/admin")) {
    return <Navigate to="/admin/user" />;
  }

  return (
    <div className={`mainsection ${thememode ? "" : "dark"}`}>
      <HeaderComponent />
      {User_Role === 'Dev' ? <Sidebar /> : User_Role === 'Admin' ? <AdminSidebarComponent /> : null}
      {children}
    </div>
  );
};

export default ProtectedRoute;
